<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select v-model="formDatas.aaId" placeholder="请选择智能体" size="small" clearable
                        style="width: 160px; margin-left: 10px" @change="partserch">
                        <el-option v-for="item in getAiAppList_data" :key="item.aaId"
                            :label="item.aatName + '-' + item.aaTitle" :value="item.aaId">
                        </el-option>
                    </el-select>
                    <el-select v-model="formDatas.auId" placeholder="请选择用户" size="small" clearable filterable
                        style="width: 160px; margin-left: 10px" @change="partserch">
                        <el-option v-for="item in getAiUserList_data" :key="item.auId" :label="item.auName"
                            :value="item.auId">
                        </el-option>
                    </el-select>
                    <!-- 状态 -->
                    <el-select v-model="formDatas.aucStatus" placeholder="请选择状态" size="small" clearable
                        style="width: 160px; margin-left: 10px" @change="partserch">
                        <el-option
                            v-for="item in [{ aucStatus: 1, aucStatusName: '未完成' }, { aucStatus: 2, aucStatusName: '已完成' }, { aucStatus: 3, aucStatusName: '已过期' }]"
                            :key="item.aucStatus" :label="item.aucStatusName" :value="item.aucStatus">
                        </el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="danger" size="small" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="small" style="margin-right: 20px"
                        @click="BoxOpen">新增智能体分类</el-button> -->

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="aucId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>

        </div>
        <el-dialog title="对话记录" :visible.sync="isChatmsg" width="90%" top="8vh" :close-on-click-modal="false"
            :close-on-press-escape="false" @close="isChatmsgClose">
            <div>
                <el-table v-if="chatMsgTableData.aiUserChatMsgList" :data="chatMsgTableData.aiUserChatMsgList || []"
                    border highlight-current-row :header-cell-style="{
                        textAlign: 'center',
                        background: 'rgba(0,170,255,0.5)',
                        color: 'black',
                        border: 'none'
                    }" style="width: 100%;margin:12px 0 0 0;">
                    <el-table-column type="index" width="50" label="序号" fixed="left">
                    </el-table-column>
                    <el-table-column prop="yuamrQuestion" label="用户询问" width="260">
                    </el-table-column>
                    <el-table-column prop="yuamrAnswer" label="智能体回答" min-width="800">
                        <template slot-scope="scope">
                            <div style="width: 100%;height: 100%;line-height: 1.5;" v-html="scope.row.yuamrAnswer">
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createtime" label="创建时间" width="160" fixed="right">
                    </el-table-column>
                    <el-table-column prop="a" label="操作" width="80" fixed="right">
                        <template slot-scope="scope">
                            <el-button v-if="chatMsgTableData && chatMsgTableData.aiApp.aaWord == 2"
                                @click="handleDownload(scope.row)" type="primary" size="small">下载</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="width: 100%;height: 300px;" aiToolsRecord
                    v-if="chatMsgTableData && chatMsgTableData.aaType == 2 && chatMsgTableData.aucStatus == 2">
                    <div ref="eCharts1" style="width: 80%;height: 100%; margin: 20px auto;"></div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import { exportAiUserChatMsgWord, getAiAppList, getAiUserList, getAiUserChatListAdmin, addAiAppType, updateAiAppType, deleteAiAppType, getAiUserChatDetails } from "../../api/api";
import echarts from "echarts";
export default {
    name: "",
    components: {},
    data() {
        return {
            getAiUserList_data: [],
            getAiAppList_data: [],
            color: [
                " #4992ff",
                " #dd79ff",
                " #fddd60",
                "  #ff6e76",
                " #58d9f9",
                " #05c091",
                "  #ff8a45",
                " #8d48e3"
            ],
            echartsStr: "",
            echartsStrValue: {
                xdata: [],
                data: []
            },
            isChatmsg: false,
            chatMsgTableData: [],

            OtherImgfileList: [],
            key: 'aucId',
            dialog: false,
            edit: false,
            form: {
                akcName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",

                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "用户名",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "aatName",
                    key: "aatName",
                    title: "智能体分类",
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag>{row.aatName}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "aaTitle",
                    key: "aaTitle",
                    title: "智能体名称",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "chatTitle",
                    key: "chatTitle",
                    title: "标题",
                    align: "center",
                    edit: false,
                    width: 400,
                },

                {
                    field: "aaType",
                    key: "aaType",
                    title: "对话类型",
                    align: "center",
                    width: 140,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aaType == 1 ? '对话' : row.aaType == 2 ? '演练' : ''
                                }
                            </span>
                        )
                    },
                    edit: false,
                },
                {
                    field: "aucStatus",
                    key: "aucStatus",
                    title: "状态",
                    align: "center",
                    width: 110,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.aucStatus == 1 ? <el-tag type="primary">对话中</el-tag> : row.aucStatus == 3 ? <el-tag type="danger">已过期</el-tag> : <el-tag type="success">已完成</el-tag>;
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    fixed: "right",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    对话记录
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                appiType: 1,
                akcName: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAiAppList().then(res => {
            if (res.data) {
                this.getAiAppList_data = res.data
            }
        })
        getAiUserList().then(res => {
            if (res.data) {
                this.getAiUserList_data = res.data
            }
        })
        this.getList();
    },
    mounted() { },
    methods: {
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        handleDownload(row) {
            this.openLoading()
            exportAiUserChatMsgWord({ yuamrId: row.yuamrId }).then(res => {
                if (res.data) {
                    const url = res.data;
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = "方案.docx";
                    this.loadings.close()
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    this.$message({
                        showClose: true,
                        message: "下载失败",
                        type: 'danger'
                    });
                    this.loadings.close()
                }
            })
        },
        // 图标配置项
        DrawEcharts() {
            console.log(this.$refs.eCharts1);
            this.echartsStr = this.$echarts.init(this.$refs.eCharts1);
            this.echartsStr.setOption({
                darkMode: " auto",
                colorBy: "series",
                color: this.color,
                // backgroundColor: '#100C2A',
                title: {
                    text: "训练分析",
                    left: "3%",
                    top: "3%"
                }, //标题位置

                tooltip: {
                    trigger: "item"
                }, //提示框组件 ---数据项图形触发
                legend: {
                    // orient: 'vertical', //图标列表的布局朝向
                    right: "3%",
                    top: "3%",
                    data: ["训练分析"]
                },
                radar: {
                    // shape: 'circle',
                    indicator: this.echartsStrValue.data
                },
                series: [
                    {
                        type: "radar",
                        radius: "80%",
                        data: [
                            {
                                value: this.echartsStrValue.xdata,
                                name: "训练分析"
                            }
                        ],

                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)"
                            }
                        }
                    }
                ]
            });
        },
        isChatmsgClose() {
            this.isChatmsg = false
            this.echartsStrValue = {
                xdata: [],
                data: []
            }
        },
        OtherImgChange(file) {
            console.log(file);
            this.$set(this.form, 'aatIcon', file[0])
            console.log(this.form.aatIcon);
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAiAppType({ aucIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAiAppType({ aucId: row.aucId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            this.echartsStrValue = {
                xdata: [],
                data: []
            };
            var maxNum = "";
            getAiUserChatDetails({ aucId: row.aucId }).then(res => {
                if (res.data) {
                    if (res.data.aucAnswerEvaluate) {
                        JSON.parse(res.data.aucAnswerEvaluate).forEach(
                            (item, index) => {
                                this.echartsStrValue.xdata = item.secondArray
                                item.firstArray.forEach(
                                    (items, index) => {

                                        this.echartsStrValue.data.push({
                                            name: items,
                                            max: ""
                                        });
                                    }
                                );
                            }
                        );
                        maxNum = Math.max(...this.echartsStrValue.xdata);
                        this.echartsStrValue.data.forEach(item => {
                            item.max = maxNum;
                        });
                    }
                    this.chatMsgTableData = res.data;
                    this.$nextTick(() => {
                        this.DrawEcharts();
                    });
                    this.isChatmsg = true
                }

            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        addAiAppType(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        updateAiAppType(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.OtherImgfileList = [];
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aucId = row.aucId
                    console.log(jsonObj);
                    updateAiAppType(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAiUserChatListAdmin(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAiUserChatListAdmin(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAiUserChatListAdmin(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>